import React, { Suspense } from 'react';
import { IDriverStandings } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LgpResultsWrapper = React.lazy(() => import('./lgp-results'));
export interface IDynamicLgpResultsWrapper extends IComponentModel<IDriverStandings> {
  live?: boolean;
  model: any;
}

const DynamicLgpResults = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicLgpResultsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <LgpResultsWrapper
      live={live}
      initialModel={validateModel(model) as IDriverStandings}
      query={validateModel(query)}
    />
  </Suspense>
);

DynamicLgpResults.defaultProps = {
  live: false,
};

export default DynamicLgpResults;
